import { CustomNode } from '../../../types';
import { sendWebPushIcon } from '../../../icons';

const DEFAULT_ICON = sendWebPushIcon;

export const sendWebPushConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
